import { SaveButton, SimpleForm, TextInput, Toolbar } from 'react-admin'
import { Typography } from '@mui/material'
import { FieldValues } from 'react-hook-form'
import Modal from '../../../components/Modal'
import useInvite from '../hooks/useInvite'

export type Props = {
  open: boolean
  onClose: () => void
}

const FormButtons = () => (
  <Toolbar>
    <SaveButton label="Invite" icon={<></>} />
  </Toolbar>
)

const InviteUser = ({ open, onClose }: Props) => {
  const { invite } = useInvite({ onInviteSuccess: onClose })

  const handleSubmit = (values: FieldValues) => {
    invite({
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email
    })
  }

  return (
    <Modal open={open} onClose={onClose}>
      <SimpleForm
        data-testid="invite-user-form"
        onSubmit={handleSubmit}
        toolbar={<FormButtons />}
      >
        <Typography variant="h6" gutterBottom>
          Invite New User
        </Typography>
        <TextInput
          source="firstName"
          label="First Name"
          inputProps={{ 'data-testid': 'first-name' }}
          isRequired
          fullWidth
        />
        <TextInput
          source="lastName"
          label="Last Name"
          inputProps={{ 'data-testid': 'last-name' }}
          isRequired
          fullWidth
        />
        <TextInput
          source="email"
          label="E-mail"
          type="email"
          inputProps={{ 'data-testid': 'email' }}
          isRequired
          fullWidth
        />
      </SimpleForm>
    </Modal>
  )
}

export default InviteUser
